import { onBeforeMount } from '@vue/composition-api'
import $fetch from '@/api'
import { openMessage } from '@/utils/system.tsx'
import getGoodsCommonData from './goods_data'
import { getDataFromStorage } from './goods_utils'

export default function(ctx) {
    const {
        isGroupLoading,
        goodsGroup,
        currentActiveGroup,
        allGoodsCount,
        noGroupGoodsCount,
        hasGroupGoodsCount
    } = getGoodsCommonData()

    onBeforeMount(() => {
        getGoodsGroup()
    })

    function getGoodsGroup() {
        isGroupLoading.value = true
        return Promise.all([
            getAllGoodsSum(),
            getGroup()
        ]).then(([num, _]) => {
            if (num != null) {
                allGoodsCount.value = num
                noGroupGoodsCount.value = num - hasGroupGoodsCount.value
            }
            isGroupLoading.value = false
        })
    }

    function getAllGoodsSum() {
        return $fetch.post({
            url: '/goods/getgoodsnumber',
        }).then(data => {
            return data.number
        }).catch(e => {
            openMessage('error', e.message)
        })
    }

    function getGroup() {
        return $fetch.post({
            url: '/goods/getgoodsgroup',
        }).then((newGroupData: any) => {
            setGroup(newGroupData)

            return goodsGroup.value
        }).catch(e => {
            openMessage('error', e.message)
        })
    }

    function setGroup(newGroupData) {
        if (goodsGroup.value.length > 0) {
            goodsGroup.value = newGroupData.map((newData: any) => {
                const target = goodsGroup.value.find(oldGroupData => oldGroupData.id === newData.id)
                if (target) {
                    newData.isExpand = target.isExpand
                } else {
                    newData.isExpand = false
                }
                if (newData.group_type === 0 || newData.secondary_group.length === 0) {
                    return newData
                }
                newData.goods_num = newData.secondary_group.reduce((next, prev) => (next += prev.goods_num, next), 0)
                return newData
            })
        } else {
            const storageLevel1 = getDataFromStorage('GOODS_LEVEL1')
            goodsGroup.value = newGroupData.map((newData: any) => {
                if (newData.id === storageLevel1) {
                    newData.isExpand = true
                } else {
                    newData.isExpand = false
                }
                if (newData.group_type === 0 || newData.secondary_group.length === 0) {
                    return newData
                }
                newData.goods_num = newData.secondary_group.reduce((next, prev) => (next += prev.goods_num, next), 0)
                return newData
            })
        }
        hasGroupGoodsCount.value = goodsGroup.value.reduce((next, prev) => {
            next += prev.goods_num
            return next
        }, 0)
    }

    function onLevel2Move(evt: any) {
        console.log(evt)
        if (evt.to.classList.contains('goods-tbody')) {
            return false
        }
    }

    function onLevel1DragEnd(evt) {
        console.log(arguments)
        const order = [...evt.to.childNodes].map(value => {
            return +value.dataset.level1Id
        })

        orderLevelGroup({
            group_ids: order
        })
    }

    function onLevel2DragEnd(evt) {
        console.log(arguments)
        const order = [...evt.to.childNodes].map(value => {
            return +value.dataset.level2Id
        })

        orderLevelGroup({
            secondary_group_ids: order
        })
    }

    function orderLevelGroup(params) {
        $fetch.post({
            url: '/goods/editgrouppriority',
            params
        }).catch(e => {
            openMessage('error', e.message)
        })
    }

    function level1Dragenter(goodsInfo, evt, level1) {
        if (goodsInfo == null) {
            // 移动的是分组
        } else {
            // 移动的是商品
            level1.isExpand = true
        }
    }

    return {
        allGoodsCount,
        noGroupGoodsCount,
        hasGroupGoodsCount,
        goodsGroup,
        currentActiveGroup,
        onLevel2Move,
        isGroupLoading,
        getGoodsGroup,
        onLevel1DragEnd,
        onLevel2DragEnd,
        level1Dragenter
    }
}
